export default {
    props: {
        formData: Object,
        integration: Object,
        requiredFields: Array,
        store: Object,
        action: String
    },

    data() {
        return {
            config: this.$inertia.form(this.formData)
        };
    },

    methods: {
        saveAndContinue() {
            this.config.transform((data) => {
                return {
                    formData: data,
                    action: this.action
                };
            }).post(this.$route('integration.store.config.save', [this.integration.code, this.store.id]));
        },

        preventLeavingWithUnsavedChanges(event) {
            if (this.config.isDirty) {
                //TODO: use sweetalert

                if (!confirm('Abort with unsaved changes?')) {
                    event.preventDefault();
                }
            }
        }
    }
};
